var map = {
	"./7-eleven_logo.svg.png": 92124,
	"./American-Express-logo.png": 87914,
	"./Mastercard-logo.png": 6994,
	"./Maybank-logo.png": 32145,
	"./VISA-logo.png": 28789,
	"./download (2).png": 46828,
	"./download.png": 16223,
	"./fpx-logo-vector-01.png": 91449,
	"./z-QR.png": 91477,
	"Common/Components/AppFooter/Assets/Icons/Png/7-eleven_logo.svg.png": 92124,
	"Common/Components/AppFooter/Assets/Icons/Png/American-Express-logo.png": 87914,
	"Common/Components/AppFooter/Assets/Icons/Png/Mastercard-logo.png": 6994,
	"Common/Components/AppFooter/Assets/Icons/Png/Maybank-logo.png": 32145,
	"Common/Components/AppFooter/Assets/Icons/Png/VISA-logo.png": 28789,
	"Common/Components/AppFooter/Assets/Icons/Png/download (2).png": 46828,
	"Common/Components/AppFooter/Assets/Icons/Png/download.png": 16223,
	"Common/Components/AppFooter/Assets/Icons/Png/fpx-logo-vector-01.png": 91449,
	"Common/Components/AppFooter/Assets/Icons/Png/z-QR.png": 91477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55394;